 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"vendors~locale-data-polyfill-da~locale-data-polyfill-de~locale-data-polyfill-es~locale-data-polyfill~97f2107a","9":"locale-data-da","10":"locale-data-de","11":"locale-data-es","12":"locale-data-ga","13":"locale-data-gb","14":"locale-data-he","15":"locale-data-hu","16":"locale-data-id","17":"locale-data-it","18":"locale-data-ja","19":"locale-data-ko","20":"locale-data-ms","21":"locale-data-nl","22":"locale-data-no","23":"locale-data-polyfill-da","24":"locale-data-polyfill-de","25":"locale-data-polyfill-es","26":"locale-data-polyfill-fr","27":"locale-data-polyfill-ga","28":"locale-data-polyfill-he","29":"locale-data-polyfill-hu","30":"locale-data-polyfill-id","31":"locale-data-polyfill-it","32":"locale-data-polyfill-ja","33":"locale-data-polyfill-ko","34":"locale-data-polyfill-ms","35":"locale-data-polyfill-nl","36":"locale-data-polyfill-no","37":"locale-data-polyfill-pt","38":"locale-data-polyfill-ro","39":"locale-data-polyfill-ru","40":"locale-data-polyfill-sv","41":"locale-data-polyfill-th","42":"locale-data-polyfill-tr","43":"locale-data-polyfill-vi","44":"locale-data-polyfill-zh","45":"locale-data-pt","46":"locale-data-ro","47":"locale-data-ru","48":"locale-data-sv","49":"locale-data-th","50":"locale-data-tr","51":"locale-data-vi","52":"locale-data-zh","55":"lps-gr-chat","56":"lps-webfont-module"}[chunkId]||chunkId) + ".chunk." + {"1":"e6535b1afe01c55bc02b","9":"e342c2ecce2edf7844bc","10":"79ff6a2648fd6a4c4e4a","11":"24d4d789280d04d76b2b","12":"687dc5d1eec11c7d1cd9","13":"4bda8771cda2d2a48a31","14":"ef560dd9a15d629fb878","15":"458359d60c4fd3a071ea","16":"08a3d309594aaff3e5c8","17":"c684948d22efa8fe4f20","18":"23dd0d5a4e6b1b326273","19":"80bb0de7b7750fd46309","20":"3a439751f7fb8c397bbc","21":"64a1a78e6050bdfb3a3b","22":"2ea24315ee2f022de022","23":"e57d685c6b523a9e7023","24":"6f3a4157b454b3bfd886","25":"07436525326e0f9c19e3","26":"4024c2c25a6d2300e5f1","27":"985d342cb4300dcc6ce9","28":"2d40590ba4dfa064e574","29":"cb67e1f237804ff47281","30":"89bdae403a5fd8c5212f","31":"0085110bab498d050357","32":"cc438a558982d9ff3ae3","33":"e34c65a343dbf845681c","34":"c9870e3fc8f34d457f8a","35":"860027e5bfa0e9b1743b","36":"a0bda02c81e1960f66a6","37":"bcb51485132cf814532f","38":"d158fe74936fced89bc8","39":"5c3c9f685eb698e7a477","40":"09a56e7ded8dc1bd4516","41":"33330d8707a726280a96","42":"60d6d111ac9e67b7af2f","43":"e2c68ea600e5037d3709","44":"c7221aa121d1c734a4fb","45":"c847ff8db06df44d3856","46":"00d910bc8796d6e322e8","47":"5dc4cb400f7283df4af1","48":"5051b56fb04c6a6abdd9","49":"e63124948f8c68c91df2","50":"eac660d07da9d970d2ca","51":"bd7d2c925f55a681d54d","52":"cb2be1c53e74c8de4882","55":"7359e3a14a41fa68b8cc","56":"3ed1ea28706a3f96139c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/javascripts/core/lps/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
